import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  TextField,
  Typography
} from "@mui/material";
import { snackActions } from "../../utils/SnackBarUtils";
import {SuittService} from "../../services/index";
import { Page } from "../../components";

const initFormState = {
  nameError: false,
  messageError: false
};


function Support() {
  const suittService = new SuittService();
  const [supportForm, setSupportForm] = useState({
    name: "",
    email: "",
    message: "",
    sending: false,
    errors: []
  });
  const [supportFormState, setSupportFormState] = useState(initFormState);

  const doValidateForm = () => {
    const {
      name,
      email,
      message
    } = supportForm;

    const errors = { ...initFormState };

    if (name === "") errors.nameError = true;
    if (email === "") errors.emailError = true;
    if (message === "") errors.messageError = true;

    // If at least one of errors is true - set false state
    const state = !Object.values(errors).some((error) => error);

    setSupportFormState({
      ...supportFormState,
      ...errors
    });

    return state;
  };

  const sendSupportForm = async () => {
    const isValidForm = doValidateForm();
    if (!isValidForm) {
      return setSupportForm({ ...supportForm, sending: false, errors: [] });
    }

    const result = await suittService.sendSupportForm(supportForm);
    if(!result) {
      snackActions.error('Помилка сервера. Повторіть спробу пізніше');
      return setSupportForm({
        ...supportForm,
        sending: false
      });
    }

    if (result && result.code === 200) {
      snackActions.success('Запит успішно надіслано');
      setSupportForm({
        name: "",
        email: "",
        message: "",
        errors: [],
        sending: false
      });
    } else {
      setSupportForm({
        ...supportForm,
        errors: result.errors,
        sending: false
      });
    }
  };

  return (
    <Page title="Контакти">
      <Box sx={{
        minHeight: '75vh',
        display: "flex",
        flexDirection: "column",
        justifyContent: 'center'
      }}>
        <Typography variant={"h4"} component={"h2"} fontWeight={"500"} align={"center"} sx={{
          marginTop: "15px"
        }}>
          Форма зворотного зв'язку
        </Typography>
        <Grid container>
          <Grid item md={12} sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: "15px"
          }}>
            <Box sx={{ maxWidth: 600, padding: "20px 5px", margin: "0 auto" }}>
              <FormControl sx={{ mt: 3 }} variant="standard">
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <TextField
                      placeholder={'Введіть ПІБ'}
                      label={'ПІБ'}
                      variant="outlined"
                      fullWidth
                      required
                      error={supportFormState.nameError}
                      onChange={(e) => setSupportForm({ ...supportForm, name: e.target.value })}
                      value={supportForm.name}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      type="email"
                      placeholder={'Email'}
                      label="Email"
                      variant="outlined"
                      fullWidth
                      required
                      error={supportFormState.emailError}
                      onChange={(e) => setSupportForm({ ...supportForm, email: e.target.value })}
                      value={supportForm.email}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      placeholder={'Введіть повідомлення'}
                      label={'Повідомлення'}
                      variant="outlined"
                      fullWidth
                      required
                      error={supportFormState.messageError}
                      onChange={(e) => setSupportForm({ ...supportForm, message: e.target.value })}
                      value={supportForm.message}
                      multiline={true}
                      rows={7}
                    />
                  </Grid>
                  <Grid item xs={12} display={"flex"} justifyContent={"center"}>
                    {supportForm.sending ? (
                      <CircularProgress color={"secondary"} />
                    ) : (
                      <Button
                        size="large"
                        type="submit"
                        variant="contained"
                        fullWidth
                        color="primary"
                        onClick={(e) => {
                          e.preventDefault();

                          setSupportForm({
                            ...supportForm,
                            sending: true
                          });

                          setTimeout(async () => {
                            await sendSupportForm();
                          }, 500);
                        }}
                      >
                        Надіслати
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </FormControl>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Page>
  );
}

export default Support;
